module.exports = __webpack_public_path__ + "img/WartenScaled.6be38a4e.jpg";